<template>
    <NavAndBody>
        <h1 class="page-title">작품 간편 생성</h1>
    </NavAndBody>
</template>

<script>
    import NavAndBody from '@/components/layout/NavAndBody';
    import {RepositoryFactory} from '@/repositories/RepositoryFactory';

    const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

    export default {
        name: 'ArtCreateView',
        components: {NavAndBody},
        async created(){
            const {data} = await PrintingDiyRepository.getUserInfo();
            console.log(data)

        }
    };
</script>

<style lang="scss" scoped>

</style>